import React from 'react';

const Share = () => {
  return (
    <svg
      width="26px"
      height="26px"
      viewBox="0 0 26 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Ecran-2---impayé-Copy"
          transform="translate(-332.000000, -101.000000)"
          fill="#E84249"
          fillRule="nonzero"
        >
          <g id="envoyer" transform="translate(332.000000, 101.000000)">
            <path
              d="M0.504747996,9.04009205 L10.5903111,15.4100093 L16.9603771,25.4950724 C17.1606072,25.812206 17.5079018,26 17.8763568,26 C17.9255547,26 17.9760751,25.996826 18.025802,25.9896845 C18.4466288,25.9312304 18.7949815,25.6318181 18.9158602,25.2236969 L25.9580325,1.38920866 C25.9715223,1.34265693 25.9770769,1.29557616 25.984483,1.24902443 C25.9871281,1.23289003 25.9916246,1.21807812 25.9937407,1.20194373 C26.0056434,1.09746681 25.9999654,0.99484139 25.9818379,0.894331963 C25.9786639,0.874759108 25.9741673,0.855715216 25.9694062,0.836142294 C25.9450718,0.732723366 25.9080411,0.633536482 25.8556692,0.542019969 C25.8530242,0.537787993 25.8530242,0.533027054 25.8501146,0.528530597 C25.8294832,0.49441024 25.8051488,0.463992897 25.7813434,0.432782108 C25.7699697,0.417441162 25.7607121,0.401306771 25.7482803,0.386759404 C25.7062241,0.336240175 25.6604648,0.290746434 25.6112669,0.249484669 C25.5988351,0.239169211 25.5853455,0.231763253 25.5723847,0.221976826 C25.53218,0.191559482 25.4909172,0.162993645 25.447274,0.138659784 C25.4282296,0.127815362 25.4081273,0.119086861 25.3880249,0.109829465 C25.3454397,0.0891985485 25.3020609,0.0714772002 25.2576241,0.0561362537 C25.2467795,0.0524333087 25.2369927,0.0463498264 25.2256191,0.0431758445 C25.2153034,0.0400018625 25.2049877,0.0400018625 25.195201,0.0373568437 C25.1475902,0.0246609161 25.0994503,0.0161969643 25.050517,0.00958451886 C25.0317371,0.00746853091 25.0126928,0.003765552 24.9936485,0.00191406593 C24.9351929,-0.00125991599 24.8762084,-0.000730925772 24.8172239,0.00535254296 C24.8100822,0.00588153995 24.8024116,0.00535254296 24.7950055,0.00588153995 C24.7336404,0.0127585008 24.6720108,0.0254544285 24.6114392,0.0431758445 L0.77639431,7.08518373 C0.368263654,7.20605953 0.0688442988,7.55387507 0.0103887834,7.97522115 C-0.0483312197,8.39603827 0.145286199,8.81262341 0.504747996,9.04009205 L0.504747996,9.04009205 Z M21.1400799,3.32798265 L16.5686457,7.89983909 C16.1454383,8.32303668 16.1454383,9.00888126 16.5686457,9.43181437 C16.9910597,9.85501196 17.6779783,9.85501196 18.1006568,9.43181437 L22.67262,4.85995793 L17.5150434,22.316065 L12.7539593,14.7783869 L14.8504234,12.6819719 C15.2733663,12.2590387 15.2733663,11.5731942 14.8504234,11.1499966 C14.4277449,10.7270635 13.7408263,10.7270635 13.3184123,11.1499966 L11.2219483,13.2458826 L3.68409421,8.48543873 L21.1400799,3.32798265 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Share;
